import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import store from '@/store';
import { stAccountApi } from '@/services/st-api';
import { PaymentStatusViewModel} from '@/services/api/nswag/stapiclient_generated';
import {getLogo} from '@/utlitities/helper';

@Module({ dynamic: true, store, name: 'AccountModule', namespaced: true })
export default class AccountModule extends VuexModule {
  public logo: string = '';
  public base64Logo: string = '';
  public isLoaded: boolean = false;
  public paymentStatus: PaymentStatusViewModel = PaymentStatusViewModel.fromJS({});

  @Mutation
  setLogo(data: string) {
    this.logo = data;
  }

  @Mutation
  setIsLoaded(data: boolean) {
    this.isLoaded = data;
  }

  @Mutation
  setBase64Logo(data: string) {
    this.base64Logo = data;
  }

  @Mutation
  public reset() {
    this.logo = '';
    this.isLoaded = false;
  }

  @Action
  async reloadStore() {
    await this.loadLogo();
    this.setIsLoaded(true);
  }

  @Action
  async loadLogo() {
    let logoRes = await getLogo(await stAccountApi.getLogo());

    this.setLogo(logoRes.logo);
    this.setBase64Logo(logoRes.logoBase64);
  }
}

export const AccountStore = getModule(AccountModule);
